import { createElement, FunctionComponent } from 'react';
import { createRoot } from 'react-dom/client';

export class WidgetHelper {
    /**
     * Renders the widget using React. 
     * @param component The Function Component to render.
     * @param selectors The query selector used to select the node.
     */
    public static register<P extends {}>(
        component: FunctionComponent<P>,
        selectors: string,
    ) : void {
        const hosts = document.querySelectorAll(selectors);

        for (let i = 0, c = hosts.length; i < c; i++) {
            const host = hosts[i] as HTMLElement;
            const domChildren: Element[] = [];

            for (let j = 0, jc = host.children.length; j < jc; j++) {
                domChildren.push(host.children[j]);
            }
            
            const componentProps: any = { ...host.dataset, domChildren };
            createRoot(host).render(createElement(component, componentProps));
            host.classList.add('widget-loaded');
        }
    }
}